import {AgGridModule} from 'ag-grid-angular';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
import { TooltipModule } from 'ng2-tooltip-directive';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import {LfsaBotonsGridComponent} from '../../shared/components/lfsa-botons-grid/lfsa-botons-grid.component';
import {
  LfsaBotonEditarGridComponent
} from '../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {SharedModule as GlobalShared} from '../../shared/shared.module';
import { PromocionesRoutingModule } from './promociones-routing.module';
import { PromocionesComponent } from './views/promociones/promociones.component';
import { DuplicarPromocionComponent } from './components/duplicar-promocion/duplicar-promocion.component';
import { EditarPromocionComponent } from './views/editar-promocion/editar-promocion.component';
import { PromocionFormComponent } from './components/promocion-form/promocion-form.component';
import { PromocionBonificadoresComponent } from './views/promocion-bonificadores/promocion-bonificadores.component';
import { PromoBonoFormComponent } from './components/promo-bono-form/promo-bono-form.component';
import { SharedModule as VdiShared } from '../vdi/shared/shared.module';
import { PromocionRegalosComponent } from './views/promocion-regalos/promocion-regalos.component';
import { PromoRegaloFormComponent } from './components/promo-regalo-form/promo-regalo-form.component';
import { PromocionGruposComponent } from './views/promocion-grupos/promocion-grupos.component';
import { PromoGrupoFormComponent } from './components/promo-grupo-form/promo-grupo-form.component';
import { PromocionGrupoClienteComponent } from './views/promocion-grupo-cliente/promocion-grupo-cliente.component';
import { PromoGrupoClienteFormComponent } from './components/promo-grupo-cliente-form/promo-grupo-cliente-form.component';
import { PromocionOficinasComponent } from './views/promocion-oficinas/promocion-oficinas.component';
import { PromoOficinaFormComponent } from './components/promo-oficina-form/promo-oficina-form.component';
import { PromoClienteFormComponent } from './components/promo-cliente-form/promo-cliente-form.component';
import { PromocionClientesComponent } from './views/promocion-clientes/promocion-clientes.component';
import { PromocionVendedoresComponent } from './views/promocion-vendedores/promocion-vendedores.component';
import { PromoVendedorListComponent } from './components/promo-vendedor-list/promo-vendedor-list.component';
import { PromocionSubmarcaComponent } from './views/promocion-submarca/promocion-submarca.component';
import { PromoSubmarcaListComponent } from './components/promo-submarca-list/promo-submarca-list.component';
import { SimpleAccordionModule } from 'src/app/shared/components/simple-accordion/simple-accordion.module';
import { PromoAccordionComponent } from './components/promo-accordion/promo-accordion.component';
import { PromocionCondicionesComponent } from './views/promocion-condiciones/promocion-condiciones.component';
import { PromoTierFormComponent } from './components/promo-cond-tier-form/promo-cond-tier-form.component';
import { PromoAgrupacionTarifaComponent } from './components/promo-agrupacion-tarifa-form/promo-agrupacion-tarifa.component';
import { PromoCanalVendedorFormComponent } from './components/promo-canal-vendedor-form/promo-canal-vendedor-form.component';
import { ModalVariantesComponent } from './components/modal-variantes/modal-variantes.component';

@NgModule({
  declarations: [
    PromocionesComponent,
    DuplicarPromocionComponent,
    EditarPromocionComponent,
    PromocionFormComponent,
    PromocionBonificadoresComponent,
    PromoBonoFormComponent,
    ModalVariantesComponent,
    PromocionRegalosComponent,
    PromoRegaloFormComponent,
    PromocionGruposComponent,
    PromoGrupoFormComponent,
    PromocionGrupoClienteComponent,
    PromoGrupoClienteFormComponent,
    PromocionOficinasComponent,
    PromoOficinaFormComponent,
    PromoClienteFormComponent,
    PromocionClientesComponent,
    PromocionVendedoresComponent,
    PromoVendedorListComponent,
    PromocionSubmarcaComponent,
    PromoSubmarcaListComponent,
    PromoAccordionComponent,
    PromocionCondicionesComponent,
    PromoTierFormComponent,
    PromoAgrupacionTarifaComponent,   // T.20331 Essential: nuevas cond. para promos
    PromoCanalVendedorFormComponent,  // T.20331 Essential: nuevas cond. para promos
  ],
  imports: [
    CommonModule,
    GlobalShared,
    VdiShared,
    PromocionesRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule,
    NgxDatatableModule,
    AgGridModule.withComponents([LfsaBotonEditarGridComponent, LfsaBotonsGridComponent]),
    NgMultiSelectDropDownModule.forRoot(),
    SimpleAccordionModule
  ],
})
export class PromocionesModule {
}
